<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

            <!-- HEADER -->
        <div class="header accent"
        fxLayout="column" fxLayoutAlign="center center"
        fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

        <!-- TÍTULO E BOTÕES ALINHADOS -->
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
        <!-- TÍTULO -->
        <div class="logo mb-24 mb-md-0"
                fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="logo-icon s-32 mr-16">
                business
            </mat-icon>
            <span class="logo-text h1">
                Histórico de Operações Estruturadas
            </span>
        </div>
        <!-- / TÍTULO -->

        <!-- BOTÕES DE AÇÃO -->
        <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
            <!-- Botão Consultar -->
            <button mat-mini-fab
                    color="accent"
                    matTooltip="Consultar Histórico"
                    (click)="openFiltro()">
                <mat-icon>search</mat-icon>
            </button>

            <!-- Botão Importar -->
            <button mat-mini-fab
                    color="accent"
                    matTooltip="Importar Histórico"
                    (click)="openCadastro()" 
                    *ngIf="this.user.role_id == 4 || this.user.role_id == 7 || this.user.role_id == 2">
                <mat-icon>cloud_upload</mat-icon>
            </button>
        </div>
        <!-- / BOTÕES DE AÇÃO -->
        </div>
        <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->
         
        <!-- CONTENT CARD -->

        <div class="content-card">

            <mat-tab-group (selectedTabChange)="onLinkClick($event)">
                <mat-tab>
                    <ng-template matTabLabel>                                    
                        <span>Custódia	Estruturadas</span>
                    </ng-template>
                    
                    <div class="content-card">
                        <ngx-datatable 
                            #table 
                            class='material striped' 
                            [loadingIndicator]="loadingIndicator"
                            [columns]="columns" 
                            [columnMode]="'force'" 
                            [headerHeight]="50"                      
                            [footerHeight]="50"
                            [rowHeight]="'auto'"
                            [limit]="params.per_page"        
                            [rows]='rows'
                            (sort)="onSort($event)">
            
                            <ngx-datatable-column name="Data Operação" prop="data_operacao" [sortable]="false" [width]="30">
                                <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
                                    {{ data_operacao | date:'dd/MM/yyyy'}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Data Vencimento" prop="data_vencimento" [sortable]="false" [width]="30">
                                <ng-template let-rowIndex="rowIndex" let-data_vencimento="value" ngx-datatable-cell-template>
                                    {{ data_vencimento | date:'dd/MM/yyyy'}}
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true" [width]="400" >
                                <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                                    {{cliente.numero_xp}} - {{cliente.nome}}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Estrutura" prop="estrutura" [sortable]="true">
                                <ng-template let-rowIndex="rowIndex" let-estrutura="value" ngx-datatable-cell-template>
                                    {{estrutura}}
                                </ng-template>
                            </ngx-datatable-column>
                            
                            <ngx-datatable-column name="Ativo" prop="sigla_ativo" [sortable]="true">
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    <span>
                                        <b>{{row.ativo.sigla}}</b>
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Tipo" prop="tipo_movimentacao" [sortable]="true">
                                <ng-template let-rowIndex="rowIndex" let-tipo_movimentacao="value" ngx-datatable-cell-template>
                                    <span [ngClass]="{
                                        'negativo':tipo_movimentacao == 'VENDA', 
                                        'positivo': tipo_movimentacao == 'COMPRA'  
                                    }">
                                        {{tipo_movimentacao}}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Qtd. Exec" prop="qtd" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                    {{qtd | number : '1.0-0'}}
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Premio Atual" prop="preco_cliente" [sortable]="false">
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    {{row.preco_cliente | number : '1.2-2'}}
                                </ng-template>
                            </ngx-datatable-column>
            
                            <ngx-datatable-column name="Premio Mercado" prop="vlr_executado" [sortable]="true">
                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                    R$ {{ getPrecoExecutado(row)  | number : '1.2-2'}} 
                                </ng-template>
                            </ngx-datatable-column>
            
                        </ngx-datatable>
        
                        <div style="padding: 5px 10px">
                            <mat-paginator 
                                #paginator 
                                [length]="length"
                                [pageSize]="pageSize"
                                [pageSizeOptions]="pageSizeOptions"
                                (page)="pageEvent($event)">
                            </mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template matTabLabel>
                        <span>Ajuste de Custódia Estruturada</span>
                    </ng-template>
                    <div>                      
                        <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                            <div>
                                <h2>Divergência de Custódia Corretora x Prosper</h2>
                                                            
                                <div style="width: 100%; overflow: auto; max-height: 500px; border: 1px solid #ccc;">
                                    <lista-divergencia-corretora-prosper></lista-divergencia-corretora-prosper>    
                                </div>   
                            </div>

                            <div>
                                <h2>Divergência de Custódia Prosper x Corretora</h2>
                            
                                <div style="width: 100%; overflow: auto; max-height: 500px; border: 1px solid #ccc;">
                                    <ngx-datatable 
                                        #table 
                                        class='material striped' 
                                        [loadingIndicator]="loadingIndicator"
                                        [columns]="columns" 
                                        [columnMode]="'force'" 
                                        [headerHeight]="50"                      
                                        [footerHeight]="50"
                                        [rowHeight]="'auto'"
                                        [limit]="params.per_page"        
                                        [rows]='rows'
                                        (sort)="onSort($event)">            
                                    
                        
                                        <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true" [width]="300" >
                                            <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template style="width: 200px;">
                                                {{cliente.numero_xp}} - {{cliente.nome}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                        
                                        <ngx-datatable-column name="Ativo" prop="sigla_ativo" [sortable]="true">
                                            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                
                                            </ng-template>
                                        </ngx-datatable-column>
                        
                                        <ngx-datatable-column name="Qtd.Custodia Prosper" prop="qtd" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                            
                                            </ng-template>
                                        </ngx-datatable-column>
            
                                        <ngx-datatable-column name="Qtd.Custodia Corretora" prop="qtd" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                            
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Ação" prop="qtd" [sortable]="false">
                                            <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                            
                                            </ng-template>
                                        </ngx-datatable-column>
                        
                                    </ngx-datatable>
                    
                                    <div style="padding: 5px 10px">
                                        <mat-paginator 
                                            #paginator 
                                            [length]="length"
                                            [pageSize]="pageSize"
                                            [pageSizeOptions]="pageSizeOptions"
                                            (page)="pageEvent($event)">
                                        </mat-paginator>
                                    </div>
    
                                </div>   
                            </div>
                                                
                        </div>
                    </div>
                  
                </mat-tab>
            </mat-tab-group>

          
        </div>
    </div>
</div>